import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Leaf/LinkItem/LinkItem.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.LinkItem';
export {styles};